import {Guid} from "guid-typescript";
import { LabelModel } from "../LabelModel";
import HeartDrawingOverlay from "./HeartDrawingOverlay";

// import HeartDrawingOverlay from "../Planner/HeartDrawingOverlay";
// import VascularDrawingOverlay from "../Planner/VascularDrawingOverlay";
// import {Annotation, AnnotationType, Hemisphere, SavedInstance} from "../Shared/SharedClasses";



export enum Conduit
{
    LITA = "LITA",
    RITA = "RITA",
    RA = "RA",
    SVG = "SVG",
    GEA = "GEA"

}

export enum TargetType
{
    RCA = "RCA",
    RVB = "RVB", //Unusual
    AM = "AM", //Unusual
    PDA = "PDA",
    LVB = "LVB",
    CUSTOM = "CUSTOM",
    LAD = "LAD",
    DIAG = "DIAG",
    DIAG2 = "DIAG2",
    RI = "RI",
    CX = "CX",
    OM1 = "OM1",
    OM2 = "OM2",
    PLA = "PLA"

}

export enum eAnatomicalLocationComponentType
{
	TypeHiddenComponent = 0,
	TypeGraftConduit = 1,
	TypeAnastomosisSite = 2,
	TypeGraftConduitAndAnastomosisSite = 3,
	TypeGeneralLocation = 4,
	TypeGeneralLocationAndGraftConduit = 5,
	TypeGeneralLocationAndAnastomosisSite = 6,
	TypeGeneralLocationGraftConduitAndAnastomosisSite = 7,
	TypeAttribute = 8,
	TypeReservedForFutureUse = 16,
	TypeFreeText = 32,
	TypeMeasurementPoint = 64
};

export enum IndicatorState
{
		none,
		measuring,
    saved,
    measuringsaved,
}

export enum Hemisphere
{
    LEFT = "LEFT",
    RIGHT = "RIGHT"
}
export class ProcedureType{
    name: string = "";
    title: string = "";
    type: string = "";
  
  }

  export enum Tabs
{
    TTFM = "TTFM",
    Imaging = "Imaging",
}

export class Coordinate {
    x: number = 0;
    y: number = 0;
    angle?: number;
  }

export class TargetLocation extends Coordinate {
    backOfHeart?: boolean = false;
    isConduit?: boolean = false;
    //Is it a free graft on the Aorta. 
    isFree?: boolean = false;
    isMammary?: boolean = false;
  }

export class WorkStage
{
    Id : string = "";
    Title : string = "";
    Items : Array < Graft > = [];
    Checked?: boolean;
    Selected?: boolean;
    Enabled?: boolean;
    Type?: string;
}

export class Graft {
    name?: TargetType;
    conduit?: Conduit;
    //Is the conduit connected in situ.
    inSitu?: boolean;
    aortaSelected?: boolean;
    targets?: Array < Graft >;
    title?: string;
    type?: string;
    primary?: boolean;
    id?: string;
    checked?: boolean;
    selected?: boolean;

    groupId?: string;
    blankNewItem?: boolean;
    sequential?: boolean = true;
    // Auto generated grafts must be removed and consolidated into a single graft
    // before editing. Use the groupId to identify which ones fall part of it.
    autoGenerated?: boolean;
    draft?: boolean;
    // Indicates if the graft is current undergoing editing. (TODO: INvestigate if
    // this could be replaced by using auto generated)
    inEdit?: boolean;
    // annotations?: Annotation[];
    // annotationsImaging?: Annotation[];
    // annotationsMain?: Annotation[];
    // annotationsImagingMain?: Annotation[];
    // commentMain?: string;
    // comment?: string;
    // commentImaging?: string;
    // commentImagingMain?: string;

    graftFound?: Graft;

    private static newAttributesLookup: any = {};

    public static CardiacProcedureTypesLookup: any = {
          "PROC-CABG-ONCAB": { 
            index: 0,
            name: "On Pump",
        },
          "PROC-CABG-OPCAB": { 
            index: 1,
            name: "Off Pump",
        },
      
    }

    public static CardiacTimeStepsLookup: any = {
        "PROC-STEP-CABG-USASS":
        {
             index: 0,
            name: "US Assessment",
            onpumponly: false
        },
          "PROC-STEP-CABG-XCLAMPON": { 
            index: 1,
            name: "Cross Clamp On",
            onpumponly: true
        },
        "PROC-STEP-CABG-XCLAMPOFF": { 
            index: 2,
            name: "Cross Clamp Off",
            onpumponly: true
        },
      
        "PROC-STEP-CABG-PREPROT": { 
            index: 3,
            name: "Pre Protamine",
            onpumponly: false
        },
        "PROC-STEP-CABG-POSTPROT": { 
            index: 4,
            name: "Post Protamine",
            onpumponly: false
        },
    }

    // public static getCurrentAnnotationsPlain(graftIn : Graft, mainSelected : boolean = false, context : string = "TTFM") : string[]
    // {
    //     let plainAnnotations : string[] = Graft
    //         .getCurrentAnnotations(graftIn, mainSelected, context)
    //         .map((item => {
    //             return item.annotationValue1
    //         }));
    //     return plainAnnotations;
    // }

    // public static getNewInternalName(graftIn : Graft, internalType : string, mainSelected : boolean = false, context : string = "TTFM") : string
    // {
    //     let index : number = 0;
    //     // Could do this way more efficiently but lets keep it simple for now. Likely to
    //     // change.
    //     while (Graft.getCurrentAnnotationsPlain(graftIn, mainSelected, context).indexOf(internalType + index) > -1) {
    //         index++;
    //     }
    //     return internalType + index;
    // }

    // public static getActiveAnnotation(graftIn : Graft, mainSelected : boolean = false, context : string = "TTFM") : AnnotationType
    // {
    //     if (!graftIn)
    //         return null;
    //     let ActivateCommand : AnnotationType = null;
    //     for (let index = 0; index < this.getCurrentAnnotations(graftIn, mainSelected, context).length; index++) {
    //         const element = this.getCurrentAnnotations(graftIn, mainSelected, context)[index];
    //         if (element.annotationType === AnnotationType.inking && !element.annotationLocations) {
    //             ActivateCommand = AnnotationType.inking;
    //         }
    //         if (element.annotationType === AnnotationType.ruler && !element.annotationEndingLocation) {
    //             ActivateCommand = AnnotationType.ruler;
    //         }
    //     }
    //     return ActivateCommand;

    // }

    // public static getCurrentAnnotations(graftIn : Graft, mainSelected : boolean = false, context : string = "TTFM") : Annotation[]
    // {
    //     if (!graftIn) 
    //         return [];
    //     if (context === "TTFM") {

    //         if (!mainSelected) {
    //             if (!graftIn.annotations) 
    //                 return [];
                
    //             return graftIn.annotations;
    //         } else {
    //             if (!graftIn.annotationsMain) 
    //                 return [];
    //             return graftIn.annotationsMain;
    //         }

    //     } else if (context === "Imaging") {
    //         if (!mainSelected) {
    //             if (!graftIn.annotationsImaging) 
    //                 return [];
                
    //             return graftIn.annotationsImaging;
    //         } else {
    //             if (!graftIn.annotationsImagingMain) 
    //                 return [];
    //             return graftIn.annotationsImagingMain;
    //         }

    //     }
    //     return [];
    // }

    // public static getCurrentComment(graftIn : Graft, mainSelected : boolean = false, context : string = "TTFM")
    // {
    //     let valueToReturn = "";
    //     if (!graftIn) 
    //         return valueToReturn;
    //     if (context === "TTFM") {

    //         if (!mainSelected) {

    //             valueToReturn = graftIn.comment;
    //         } else {

    //             valueToReturn = graftIn.commentMain;
    //         }

    //     } else if (context === "Imaging") {
    //         if (!mainSelected) {

    //             valueToReturn = graftIn.commentImaging;
    //         } else {

    //             valueToReturn = graftIn.commentImagingMain;
    //         }

    //     }
    //     return valueToReturn
    //         ? valueToReturn
    //         : "";
    // }

    // public static addAnnotationComplex(graftIn : Graft, itemToAdd : Annotation, mainSelected : boolean = false, context : string = "TTFM", update : boolean = false) : boolean
    // {
    //   //This is not very nice code but need a way to get the correct list and set it again without needing a new layer.

    //     let annotationList : Annotation[];

    //     if (!graftIn.annotations) 
    //         graftIn.annotations = [];
        
    //     if (context === "TTFM") {

    //         if (!mainSelected) {
    //             annotationList = graftIn.annotations;

    //         } else {
    //             annotationList = graftIn.annotationsMain;
    //         }

    //     } else if (context === "Imaging") {
    //         if (!mainSelected) {
    //             annotationList = graftIn.annotationsImaging;

    //         } else {
    //             annotationList = graftIn.annotationsImagingMain;

    //         }

    //     }

    //     let valToReturn = true;


    //     if (!annotationList) 
    //         annotationList = [];
    //     if (update)
    //     {
    //     if (itemToAdd.annotationValue1.indexOf("INTERNAL:MEASURE") > -1)
    //     {
    //         //If it's an update then remove any old measure or drawing holders because they are just to toggle the buttons.
    //         if (Graft.getCurrentAnnotationsPlain(graftIn, mainSelected, context).indexOf("INTERNAL:MEASURE") > -1) {
    //           annotationList.splice(Graft.getCurrentAnnotationsPlain(graftIn, mainSelected, context).indexOf("INTERNAL:MEASURE"), 1);
    //         }
    //     }
    //     if (itemToAdd.annotationValue1.indexOf("INTERNAL:DRAW") > -1)
    //     {
    //         //If it's an update then remove any old measure or drawing holders because they are just to toggle the buttons.
    //         if (Graft.getCurrentAnnotationsPlain(graftIn, mainSelected, context).indexOf("INTERNAL:DRAW") > -1) {
    //           annotationList.splice(Graft.getCurrentAnnotationsPlain(graftIn, mainSelected, context).indexOf("INTERNAL:DRAW"), 1);
    //         }
    //     }
    //   }

    //     if (Graft.getCurrentAnnotationsPlain(graftIn, mainSelected, context).indexOf(itemToAdd.annotationValue1) > -1) {
    //         if (update) 
    //             annotationList.splice(Graft.getCurrentAnnotationsPlain(graftIn, mainSelected, context).indexOf(itemToAdd.annotationValue1), 1, itemToAdd);
    //         else 
    //             annotationList.splice(Graft.getCurrentAnnotationsPlain(graftIn, mainSelected, context).indexOf(itemToAdd.annotationValue1), 1);
    //         valToReturn = update;
    //     } else 
    //         annotationList.push(itemToAdd);
        
    //     if (context === "TTFM") {

    //         if (!mainSelected) {
    //             graftIn.annotations = annotationList;

    //         } else {
    //             graftIn.annotationsMain = annotationList;
    //         }

    //     } else if (context === "Imaging") {
    //         if (!mainSelected) {
    //             graftIn.annotationsImaging = annotationList;

    //         } else {
    //             graftIn.annotationsImagingMain = annotationList;

    //         }

    //     }
    //     return valToReturn;
    // }
    // public static addAnnotation(graftIn : Graft, item : string, mainSelected : boolean = false, context : string = "TTFM", annotationIn : AnnotationType = AnnotationType.attribute)
    // {
    //     let itemToAdd : Annotation = {
    //         x: 0,
    //         y: 0,
    //         annotationType: annotationIn,
    //         annotationValue1: item
    //     }
    //     Graft.addAnnotationComplex(graftIn, itemToAdd, mainSelected, context);
    // }
    // public static countAnnotations(graftIn : Graft, context : string = "TTFM", recurse : boolean = true, getSavedInstance?: Function, selectedIndex: number = 0) : number
    // {
    //     let runningTotal : number = 0;

    //     let savedItems = getSavedInstance ? getSavedInstance(graftIn.Id) : [];
    //     if (savedItems)
    //     {
      

    //     for (let index = 0; index < savedItems.length; index++) {
    //         const savedInstance = savedItems[index];
        

    //         runningTotal = runningTotal + SavedInstance.countAnnotations(savedInstance, context);

            
    //     }
    // }
    //     if (graftIn.Targets && graftIn.Targets.length > 0 && recurse) {
    //         for (let index = 0; index < graftIn.Targets.length; index++) {
    //             const element = graftIn.Targets[index];
    //             runningTotal = runningTotal + Graft.countAnnotations(element, context, true, getSavedInstance, selectedIndex);

    //         }
    //     }
    //         return runningTotal;
    // }
    public static newAttribute(graftIn : Graft, item : string, mainSelected : boolean = false, Context : string = "TTFM")
    {
        if (item) {
            let graftTypeCode = Context + "-" + (mainSelected
                ? "MAIN"
                : graftIn.type);
            if (!Graft.newAttributesLookup[graftTypeCode]) 
                Graft.newAttributesLookup[graftTypeCode] = [];
            Graft
                .newAttributesLookup[graftTypeCode]
                .push(item);
            // if (Context !== "Imaging")
            //   Graft.addAnnotation(graftIn, item, mainSelected, Context)
        }
    }

public static recurseFindBottomTarget =  (currentGraft: Graft): Graft | null =>
    {
        
        if (currentGraft.targets)
        {
            for (let index = 0; index < currentGraft.targets.length; index++) {
                const element = currentGraft.targets[index];
                let graftFound = this.recurseFindBottomTarget(element);
                if (graftFound)
                {
                    return graftFound;
                }
            }
        }

            if (currentGraft.name && currentGraft.type === "Target")
        {
            return currentGraft;
        }
        return null;
    }
    public static graftFound : Graft | null = null;

  //Find the root conduit of the given target
    public static recurseToFindRootConduit (rootGraft: Graft, targetName: TargetType, conduitIn: Conduit): Conduit | null
    {
        if (rootGraft.name === targetName && conduitIn)
            return conduitIn;
        if (rootGraft.targets)
        {
            for (let index = 0; index < rootGraft.targets.length; index++) {
                const element = rootGraft.targets[index];
                let conduitFound = this.recurseToFindRootConduit(element, targetName, (element.conduit ? element.conduit : (element.sequential ? conduitIn : null) as Conduit));
                if (conduitFound)
                    return conduitFound;
            }
        }
        return null;
        
    }

public static deepestGraft: Graft | null = null;
public static recurseToFindDepth(currentGraft: Graft, targetToCheckFor: TargetType, depth: number, largestdepth?: number): number 
{
   
      if (currentGraft.name === targetToCheckFor)
        {
          return depth;
        }
    
        let depthincreasing = depth;
        if (currentGraft.targets && currentGraft.targets.length > 0)
    {
      
      for (let index = 0; index < currentGraft.targets.length; index++) {
        const element = currentGraft.targets[index];
        //Depth also increases if it is the second child on a source.
        depthincreasing++;
        let foundAtDepth = this.recurseToFindDepth(element, targetToCheckFor, depthincreasing, largestdepth);
        if (foundAtDepth > 0)
        {
            
            return foundAtDepth;
          }
      }
      if (!targetToCheckFor)
      {
        //When no target is diven simply return the deepest 
        if (depthincreasing > (largestdepth as any))
        {
          this.deepestGraft = currentGraft;
          largestdepth = depthincreasing;
         // return depth;
        }
      }
     
      
    }
     //Maybe return -1 because it wasn't found?
    return depthincreasing;
}

public static recurseToFindConduit (currentGraft: Graft, targetToCheckFor: TargetType, rootConduit: Conduit): Conduit | null
{
  if (currentGraft.name === targetToCheckFor)
    {
        if (currentGraft.conduit)
            return currentGraft.conduit;
        else
            return rootConduit;

    }


    if (currentGraft.targets && currentGraft.targets.length > 0)
    {
        for (let index = 0; index < currentGraft.targets.length; index++) {
            const element = currentGraft.targets[index];
            let conduitFound = this.recurseToFindConduit(element, targetToCheckFor, currentGraft.conduit ? currentGraft.conduit : rootConduit);
            if (conduitFound)
                return conduitFound;
        }
 
    }
    return null;
}

//Seq search should check if there are any targets at all (Ignore the source and the current target).
 public static recurseTargetsForYConduits (rootGraft: Graft, childTargetName: String, seqSearch?: boolean, toIgnore?: string)
 {
     let yConduitsAtLevel: string[] = [];
 //If it's not sequential then any target is possible  except toignore.
 
 
 if (!seqSearch)
 {
     if (rootGraft.name || rootGraft.title) 
     {
     if (toIgnore !== rootGraft.name && toIgnore !== rootGraft.title && rootGraft.type !== "Source")
     {
         //No duplicates.
         if (yConduitsAtLevel.indexOf(rootGraft.name ? rootGraft.name : rootGraft.title as string) === -1)
             yConduitsAtLevel.push(rootGraft.name ? rootGraft.name : rootGraft.title as string);
     }
     }
         if (rootGraft.targets) {
             for (let index = 0; index < rootGraft.targets.length; index++) {
                 const graftChild = rootGraft.targets[index];
                 let yChildren = Graft.recurseTargetsForYConduits(graftChild, childTargetName, seqSearch, toIgnore)
                for (let indexYChild = 0; indexYChild < yChildren.length; indexYChild++) {
                    const element = yChildren[indexYChild];
                    //No duplicates.
                    if (yConduitsAtLevel.indexOf(element) === -1)
                     yConduitsAtLevel.push(element);
                    
                }
           
               }
         }
    
 }
 
 if (seqSearch)
 {
 
 if (rootGraft.name || rootGraft.title) 
 {
   if (rootGraft.targets) {
     let DoesContainChild  = false;
     for (let index = 0; index < rootGraft.targets.length; index++) {
       const graftChild = rootGraft.targets[index];
         if (graftChild.name === childTargetName)
         {
           DoesContainChild = true;
         }
     }
     DoesContainChild = false;
     //If the child target is a direct child of the current node then it is not a Y source.
     if (!DoesContainChild)
     {
        //If we are doing a seq search then ignore the source and the target itself.
        //Also make sure it is not the child of it's parent.
        if ((!seqSearch && toIgnore !== rootGraft.name && toIgnore !== rootGraft.title)|| (seqSearch && rootGraft.type !== "Source" && childTargetName !== rootGraft.name) )
            yConduitsAtLevel.push(rootGraft.name ? rootGraft.name : rootGraft.title as string);
    }
}
}
 
   if (rootGraft.targets) {
     for (let index = 0; index < rootGraft.targets.length; index++) {
         const graftChild = rootGraft.targets[index];
        
         //Then every graft with at least one target is a potential y source.
         if (graftChild.targets && graftChild.targets.length > 0) { 
           
         if (graftChild.name) 
         {
             //Comment below seems to now longer apply?
         //if it is the parent of the current one item then ignore it as a Y source because it is same as SEQ. HAAKON???? This is wrong.
         yConduitsAtLevel = yConduitsAtLevel.concat(this.recurseTargetsForYConduits(graftChild, childTargetName, seqSearch, toIgnore));
         }
         }
         else
        {
            if (seqSearch && graftChild.name && childTargetName !== graftChild.name) 
            {
                //For loose searches for sequential the target does not need to be a source.
                yConduitsAtLevel = yConduitsAtLevel.concat(this.recurseTargetsForYConduits(graftChild, childTargetName, seqSearch, toIgnore));
            }
        }
 
         }
     
 }
 }
 return yConduitsAtLevel;
 
 }


  public static recurseAndAddChild (currentGraft: Graft, targetToCheckFor: TargetType, graftToAdd: Graft) : Graft | null | undefined
{
      //when addToCommonParent is false it looks for the targetToCheckFor and adds graftToAdd to the target found.
  //Title is checked for Sources.
  if ((currentGraft.name === targetToCheckFor) || (currentGraft.title === targetToCheckFor))
    {
      //Set the previous to the last graft clicked before it changes.
   
      //The latest graft added is now the Y? Should it stay as the previous on? HAAKON
      //this.lastGraftClicked.push(graftToAdd);
      //If it is sequential then make sure to add it to the start.
      if (graftToAdd.sequential)
        currentGraft.targets?.unshift(graftToAdd);
      else
        currentGraft.targets?.push(graftToAdd);
      return currentGraft;
    }
    if (currentGraft.targets && currentGraft.targets.length > 0)
{
  for (let index = 0; index < currentGraft.targets.length; index++) {
    const element = currentGraft.targets[index];
    let ItemFound = this.recurseAndAddChild(element, targetToCheckFor, graftToAdd);
    if (ItemFound)
    {
      return ItemFound;
    }
  }
  return null;
}
  
}

    public static recurseFindBottomConduit (currentGraft: Graft, toAddTo: boolean): Graft | null
    {
        if (currentGraft.targets)
        {
        for (let index = 0; index < currentGraft.targets.length; index++) {
            const element = currentGraft.targets[index];
            let graftFound = Graft.recurseFindBottomConduit(element, toAddTo);
            if (graftFound)
            {
                return graftFound;
            }
        }
    }
        if (currentGraft.conduit || currentGraft.type === "Conduit")
        {
            if (toAddTo && currentGraft.type === "Source" && (currentGraft.targets && currentGraft.targets.length > 0))
            {
                return currentGraft.targets[0];
            }
            return currentGraft;
        }
        
        return null;
    }

    
    public static recurseTargets (currentGraft: Graft, targetToCheckFor: TargetType, remove?: boolean, ignoreDraft: boolean = false): boolean 
    {
     
        if (!remove && currentGraft.name === targetToCheckFor && (!ignoreDraft || !currentGraft.draft))
        {
         this.graftFound = currentGraft;
          return true;
        }
        if (currentGraft.targets && currentGraft.targets.length > 0)
    {
      let isFound = false;
      for (let index = 0; index < currentGraft.targets.length; index++) {
        const element = currentGraft.targets[index];

        if (remove)
          {
            isFound = this.recurseTargets(element, targetToCheckFor, remove, ignoreDraft);
            if (!isFound && element.name === targetToCheckFor)
            {
               // this.graftRemoved = element;
                     //if the target was found, it means it has been removed and so we need to set it's parent as the active one.
                     //HAAKON???? parent cannot be set to parent, should be set to the previous last graft.
                       //Set the previous to the last graft clicked before it changes.
              
                       //If the previous item selected hasns't been set or it doesn't exist anymore then set the parent graft as the last graft.
              
    
              //Take the parent as the next item in the default focus tree.
              //this.previousGraftClicked = currentGraft;
              currentGraft.targets.splice(index, 1);
                
              isFound = true;
              
            }
          }
          else{
            isFound = this.recurseTargets(element, targetToCheckFor, false, ignoreDraft);
          }
          if (isFound)
          {
            
            return isFound;
          }

      }
      if (remove && currentGraft.name === targetToCheckFor && (!ignoreDraft || !currentGraft.draft))
      {
         this.graftFound = currentGraft;
        return true;
      }
     
    }
    return false;
    }

    public static getFrequentAnnotations(graftIn : Graft, mainSelected : boolean = true, Context : string = "TTFM") : string[]
    {
        let graftTypeCode = Context + "-" + (mainSelected
            ? "MAIN"
            : graftIn.type);
        let annotationsOut : string[] = [];

        if (graftIn.type === "PreGraft") {
            annotationsOut = ["Plaque"];
        } else if (graftIn.type === "Target") {
            annotationsOut = ["Revised"];
        } else if (graftIn.type === "Source") {
            annotationsOut = ["Revised", "Distal"];
        }
        if (Context === "Imaging") {
            if (graftIn.type === "Target") {
                annotationsOut = ["Intimal flap", "Occlusion"];
            } else if (graftIn.type === "Source") {
                annotationsOut = ["Plaque"];
            }
        }

        return (Graft.newAttributesLookup[graftTypeCode]
            ? annotationsOut.concat(Graft.newAttributesLookup[graftTypeCode])
            : annotationsOut);
    }

    public static GenerateId() : string
    {
        return Guid
            .create()
            .toString();
    }

    

    public static recurseSequential(currentGraft: Graft): Graft
    {
        if (currentGraft.targets && currentGraft.targets.length > 0)
    {
    
      for (let index = 0; index < currentGraft.targets.length; index++) {
        const element = currentGraft.targets[index];
          if (element.sequential)
          {
              let itemFound =this.recurseSequential(element);
              if (itemFound)
                    return itemFound;
          }
      }
    }
    return currentGraft;
    }

     public static recurseSelected(currentGraft: Graft): Graft
    {
        if (currentGraft.selected)
            return currentGraft;
        if (currentGraft.targets && currentGraft.targets.length > 0)
        {
            for (let index = 0; index < currentGraft.targets.length; index++) {
                const element = currentGraft.targets[index];
                return Graft.recurseSelected(element);
            }
        }
    return currentGraft;
    }

    public static findGraftWithId(originalGraft: Graft, currentGraft: Graft, id: string): Graft | null
    {
        if (currentGraft.id === id)
            return originalGraft;
        if (currentGraft.targets && currentGraft.targets.length > 0)
        {
            for (let index = 0; index < currentGraft.targets.length; index++) {
                const element = currentGraft.targets[index];
                return Graft.findGraftWithId(originalGraft, element, id);
            }
        }
        return null;
    }

     public static selectGraftWithId(currentGraft: Graft, id: string): boolean
    {
        if (currentGraft.id === id)
        {   
            currentGraft.selected = true;
            return true;
        }else
        {
            currentGraft.selected = false;
        }
          
        if (currentGraft.targets && currentGraft.targets.length > 0)
        {
            for (let index = 0; index < currentGraft.targets.length; index++) {
                const element = currentGraft.targets[index];
                let found = Graft.selectGraftWithId(element, id);
                if (found) {
                    return true;
                }
            }
        }
        return false;
    }

    private static recurseGraftOut: Graft | null = Graft.getBlankGraft(false, undefined,"CABG" );
    public static getRecurseGraft(): Graft | null
    {
        return this.recurseGraftOut;
    }
    public static setRecurseGraft(graftIn: Graft | null): void
    {
        this.recurseGraftOut = graftIn;
    }

    public static recurseConduits(currentGraft: Graft, conduitToCheckFor: Conduit, remove?: boolean, goToBottom?: boolean, ignoreDraft: boolean = false): boolean
    {
        
      if (currentGraft.conduit === conduitToCheckFor && (!ignoreDraft || !currentGraft.draft))
        {
            if (goToBottom)
            {
                let itemFound =this.recurseSequential(currentGraft);
                Graft.recurseGraftOut = itemFound;
                //this.context.setRecurseGraft(itemFound);
                return true;
            }else
            {
                      Graft.recurseGraftOut = currentGraft;
                //this.context.setRecurseGraft(currentGraft);
                return true;
            }
          
        }
    
        if (currentGraft.targets && currentGraft.targets.length > 0)
    {
      let isFound = false;
      for (let index = 0; index < currentGraft.targets.length; index++) {
        const element = currentGraft.targets[index];
    
        if (remove)
          {
            if (element.conduit === conduitToCheckFor && (!ignoreDraft || !element.draft))
            {
             //this.graftRemoved = element;
                     //if the target was found, it means it has been removed and so we need to set it's parent as the active one.
                     //HAAKON???? parent cannot be set to parent, should be set to the previous last graft.
                       //Set the previous to the last graft clicked before it changes.
              
                       //If the previous item selected hasns't been set or it doesn't exist anymore then set the parent graft as the last graft.
              
    
              //Take the parent as the next item in the default focus tree.
              //this.previousGraftClicked = currentGraft;
              currentGraft.targets.splice(index, 1);
              Graft.recurseGraftOut = element;
              //this.context.setRecurseGraft(element);
              isFound = true;
              
            }else
            {
              isFound = this.recurseConduits(element, conduitToCheckFor, remove, false, ignoreDraft);
              
            }
          }
          else{
            isFound = this.recurseConduits(element, conduitToCheckFor, false, false, ignoreDraft);
          }
          if (isFound)
          {
            return isFound;
          }
      }
     
    }
  
    return false;
    }
 public static recurseAndUpdateConduits (rootGraft: Graft, conduitIn: Conduit)
    {
        if (rootGraft.sequential)
        {
            if (rootGraft.conduit)
                rootGraft.conduit = conduitIn;
            if (rootGraft.targets)
            {
                for (let index = 0; index < rootGraft.targets.length; index++) {
                    const element = rootGraft.targets[index];
                    this.recurseAndUpdateConduits(element, conduitIn);
                }
            }
        }
    }
 public static recurseFindTargetParent(graftIn: Graft, targetName: TargetType): Graft | null
    {
        
        if (graftIn.targets)
            for (let index = 0; index < graftIn.targets.length; index++) {
                const element = graftIn.targets[index];
                if (element.name === targetName)
                {
                    return graftIn;
                }
                let graftFound = this.recurseFindTargetParent(element, targetName);
                if (graftFound)
                {
                    //If it finds a graft return the parent.
                    return graftFound;
                }
            }
        
         
        return null;
    }


    public static getGraftName(graftIn: Graft, anatomicalLocations: string[] )
    {
        anatomicalLocations.push(graftIn.title ? graftIn.title : (graftIn.name ? graftIn.name : graftIn.conduit) as string);
        if (graftIn.targets && graftIn.targets.length > 0)
        {
            for (let index = 0; index < graftIn.targets.length; index++) {
                const element = graftIn.targets[index];
                Graft.getGraftName(element, anatomicalLocations);
            }
        }
    }

    public static GenerateGrafts(suggestedLabels: LabelModel[][]) : Graft[]
    {
        //THis is the root graft to return;

        let graftsOut: Graft[] = [];
  
        for (let procindex = 0; procindex < suggestedLabels.length; procindex++) {
            const procedureLabels = suggestedLabels[procindex];
            if (procedureLabels && procedureLabels.length > 0)
            {
             
            let lastGraftConfig ="";
            let stillRoot = true;
            let currentGraft : Graft = Graft.getBlankGraft(false, undefined, "CABG");
            let latestGraft: Graft = currentGraft;
        
            for (let measindex = 0; measindex < procedureLabels.length; measindex++) {
                const measurementLabel = procedureLabels[measindex];

                if (measurementLabel.name === "Y")
                {
                    //Hardcoding for Y grafts.
                    lastGraftConfig = "Y";
                }

                //First check Coronary Conduit
                if (Object.keys(Conduit).indexOf(measurementLabel.name) > -1)
                {
                    //It's a Conduit
                    let conduitName =  measurementLabel.name as Conduit;
                    if (latestGraft.conduit || latestGraft.name )
                    {
                        //If the current graft has a conduit or a target set already then add a new graft to it with a conduit.
                        let childGraft : Graft = Graft.getBlankGraft(false, undefined, "CABG");
                        childGraft.blankNewItem =false;
                        childGraft.title = conduitName;
                        childGraft.conduit = conduitName;
                        childGraft.type = "Conduit";
                        latestGraft.targets?.push(childGraft);
                        latestGraft = childGraft;
                        stillRoot = false; 
                    }else
                    {
                        let conduitInUse = false;                        
                        //If there is already this conduit in use as a source then just tack it one as a sequential target?
                        for (let index = 0; index < graftsOut.length; index++) {
                            const element = graftsOut[index];
                            if (element && element.conduit === conduitName)
                            {
                                conduitInUse = true;
                            }
                        }
                        if (!conduitInUse)
                        {
                        //If the current graft doesn't have a conduit then we set it here and assume we are at the root.
                        latestGraft.inSitu = TargetDetails.getTargetDetail(conduitName).isSource;
                        latestGraft.type = "Source";
                        latestGraft.blankNewItem =false;
                        latestGraft.title = conduitName;
                        latestGraft.conduit = conduitName;
                        latestGraft.targets =[];
                        }
                    }
                }

                if (Object.keys(TargetType).indexOf(measurementLabel.name) > -1)
                {
                    //It's a Target

                    let targetName =  measurementLabel.name as TargetType;

                    //First check if it's used before and if so then don't add it.
                    let targetAddedBefore = false;
                    for (let index = 0; index < graftsOut.length; index++) {
                        const elementGraft = graftsOut[index];
                        if (Graft.recurseTargets(elementGraft, targetName))
                        {
                            targetAddedBefore = true;
                        }
                        
                    }
                    //TODO: In future we can check if the target has been added with the same conduit because it could be grafted twice maybe?
                    if (!targetAddedBefore)
                    {
               

                    if ((latestGraft.conduit && latestGraft.type==="Source") || latestGraft.name )
                    {
                        //If the current graft has a conduit and it's at the root or a target set already then add a new graft to it with a target set.
                        let childGraft : Graft = Graft.getBlankGraft(false, undefined, "CABG");
                        childGraft.sequential = lastGraftConfig !== "Y";
                        childGraft.blankNewItem =false;
                        childGraft.title =  measurementLabel.name;
                        lastGraftConfig = "";
                        childGraft.type = "Target";
                        childGraft.name = measurementLabel.name as TargetType;
                        latestGraft.targets?.push(childGraft);
                        latestGraft = childGraft;
                        stillRoot = false; 
                    }
                    else if (!latestGraft.conduit &&  stillRoot)
                    {
                        //If there is already this conduit in use as a source then just tack it one as a sequential target?
                        let conduitInUse = false;  
                        let graftWithConduit = Graft.getBlankGraft(false, undefined, "CABG");            

                        for (let index = graftsOut.length-1; index >= 0; index--) {
                            const element = graftsOut[index];
                            if (element && element.type === "Source")
                            {   
                                //Get the last added source and add the target onto it.
                                graftWithConduit = element;
                                conduitInUse = true;
                            }
                        }

                        //If there is already this conduit in use as a source then find the bottom of the conduit and tack it onto that one.
                        let targetAddedBefore = false;
                   
                        for (let index = 0; index < graftsOut.length; index++) {
                            const elementGraft = graftsOut[index];
                            if (!targetAddedBefore)
                            {
                           
                                if (Graft.recurseConduits(elementGraft, graftWithConduit.conduit as Conduit, false, true))
                                {
                                    graftWithConduit = Graft.recurseGraftOut as Graft;
                                    targetAddedBefore = true;
                                }
                                 
                            }
                        }
                        


                      

                        //If we are still at the root and the conduit is blank then lets create a default inflow.
                        
                        if (!conduitInUse)
                        {
                        latestGraft.type = "Source";
                        latestGraft.conduit = Conduit.LITA;
                        latestGraft.inSitu = true;
                        latestGraft.blankNewItem =false;
                        latestGraft.title =  Conduit.LITA;
                        }
                        let childGraft : Graft = Graft.getBlankGraft(false, undefined, "CABG");
                        childGraft.type = "Target";
                        childGraft.name = targetName;
                        childGraft.title =  targetName;
                        childGraft.sequential = lastGraftConfig !== "Y";
                        childGraft.targets =[];
                        if (!conduitInUse)
                        {
                        latestGraft.targets =[childGraft];
                        }else
                        {
                            graftWithConduit.targets?.push(childGraft);
                        }

                        latestGraft = childGraft;
                    }
                    else
                    {
                      

                        //If the current graft doesn't have a conduit then we set it here and assume we are at the root.
                        latestGraft.inSitu = TargetDetails.getTargetDetail(targetName).isSource;
                        latestGraft.type = "Target";
                        latestGraft.name = targetName;
                        latestGraft.blankNewItem =false;
                        latestGraft.title = targetName;
                        latestGraft.sequential = lastGraftConfig === "Y";
                        latestGraft.targets =[];
                    }
                }
                }


          
        }
        if (!currentGraft.blankNewItem)
            graftsOut.push(currentGraft);
        }
           
        }
        return graftsOut;
    }



    public static SetId
        ? (graftIn : Graft, IdInput?: string, GroupInput?: string)
    {
        if (!IdInput) 
            IdInput = Guid.create().toString();
        graftIn.id = IdInput;

        if (!GroupInput) 
            GroupInput = Guid.create().toString();
        graftIn.groupId = GroupInput;
        // graftIn.GroupId = Context + "_" + Stage;   if (ParentName)   { //graftIn.Id
        // += "_" +ParentName ;   }   if (graftIn.Primary)   { graftIn.Id +=
        // "_Primary_";   }   if (graftIn.AutoGenerated)   {   }   if (graftIn.Conduit)
        // {     graftIn.Id += "_" +graftIn.Conduit; graftIn.GroupId += "_"
        // +graftIn.Conduit;   }   if (graftIn.BlankNewItem)   {    graftIn.Id +=
        // "_UNDEFINEDGRAFT";     graftIn.GroupId += "_UNDEFINEDGRAFT";   }   else   {
        // if (graftIn.Name)     {     graftIn.Id += "_" +graftIn.Name; graftIn.GroupId
        // += "_" +graftIn.Name;     }   }
    }

    public static ResetAllIds(graftIn : Graft, GroupInput : string, savedTTFMItems : any, savedImagingItems : any, maintainSaves: boolean = true)
    {
        let originalId = graftIn.id as string;
        if (Graft.SetId)
        Graft.SetId(graftIn, "", GroupInput);
        if (maintainSaves)
        {
            if (savedTTFMItems[originalId]) {
                savedTTFMItems[graftIn.id as string] = savedTTFMItems[originalId];
            }
            if (savedImagingItems[originalId]) {
                savedImagingItems[graftIn.id as string] = savedImagingItems[originalId];
            }
        }
        // When resting the graft id, make sure to change the saved item ID as well. if
        // (savedTTFMItemsWithoutParent && savedImagingItemsWithoutParent)      {
        // //let primaryFound = graftIn.Id;      if (graftIn &&
        // (Object.keys(savedTTFMItemsWithoutParent).indexOf(originalId) > -1 ||
        // Object.keys(savedImagingItemsWithoutParent).indexOf(originalId) > -1)) { //If
        // previous data was saved then link it up correctly and check the item.
        // graftIn.Checked = true;       if (savedTTFMItemsWithoutParent[originalId]) {
        //          Graft.SetId(graftIn, savedTTFMItemsWithoutParent[originalId],
        // graftIn.GroupId);       }       else {         graftIn.Checked = false; }
        // if(savedImagingItemsWithoutParent[originalId])   { Graft.SetId(graftIn,
        // savedImagingItemsWithoutParent[originalId], graftIn.GroupId);           }   }
        // else {         graftIn.Checked = false;   } }

        if (graftIn.targets && graftIn.targets.length > 0) {
            for (let index = 0; index < graftIn.targets.length; index++) {
                const element = graftIn.targets[index];
                Graft.ResetAllIds(element, GroupInput, savedTTFMItems, savedImagingItems, maintainSaves);
            }
        }

    }

    public static CompareIds(Id1 : string, Id2 : string)
    {
        if (Id1 === Id2) {
            // if (Id1.substring(Id1.indexOf("_")) === Id2.substring(Id2.indexOf("_")) ) {
            return true;

            //}
        }
        return false;

    }

    // public static getVascularBlankGraft(isProcedure : boolean) : VascularGraft
    // {
    //     if (!isProcedure) {

    //         let blankGraft = {
    //             Id: "UNDEFINED_GRAFT",
    //             Type: "NewGraft",
    //             Targets: [],
    //             BlankNewItem: true,
    //             Selected: false,
    //             Title: "SELECT CAROTID",
    //             CarotidVessels: []
    //         };
    //         return blankGraft;
    //     } else {
    //         let blankGraft = {
    //             Id: "UNDEFINED_GRAFT",
    //             Type: "NewGraft",
    //             Targets: [],
    //             BlankNewItem: true,
    //             Selected: false,
    //             Title: "DEFINE PROCEDURE",
    //             CarotidVessels: []
    //         };
    //         return blankGraft;
    //     }

    // }

    public static getBlankGraft(isSelected?: boolean, duplicateInOtherTab?: Graft, selectedProcedure?: string) : Graft {
        let titleIn = "NEW GRAFT";
        let CardotidsIn = null;
        if (selectedProcedure === "CABG")
            titleIn = "NEW GRAFT";
        else 
        if (selectedProcedure === "OtherCardiac")
            titleIn = "NEW TARGET";
        else if (selectedProcedure === "Carotid")
        {
            titleIn = "DEFINE"; 
            CardotidsIn = [];
        }
        else if (selectedProcedure === "PeripheralBypass")
        {
            titleIn = "VESSEL DISEASE"; 
            CardotidsIn = [];
        }
        else if (selectedProcedure === "AVAccess")
        {
            titleIn = "DEFINE"; 
            CardotidsIn = [];
        }else
        {
            titleIn = "NEW VESSEL";
        }
        
            
        let blankGraftOver = {
            id: "UNDEFINED_GRAFT",
            type: "NewGraft",
            targets: [],
            selected: isSelected,
            blankNewItem: true,
            draft: true,
            title: titleIn,
            carotidVessels: CardotidsIn
        };

        if (!duplicateInOtherTab &&  Graft.SetId) 
            Graft.SetId(blankGraftOver);
        else 
        if (Graft.SetId)
            Graft.SetId(blankGraftOver, (duplicateInOtherTab as Graft).id, (duplicateInOtherTab as Graft).groupId);
        return blankGraftOver;
    }

}
//THis is called TargetDetail but is also used for Conduits.
export class TargetDetail
{
    priority : number = 0;
    mostUsed?: boolean = false;
    color?: string = "var(--BernRed)";
    //This defines whether the Conduit is a Source
    isSource?: boolean = false;
    isMammary?: boolean = false;
    vascular?: boolean = false;
    upperLimb?: boolean = false;
}

export class TargetDetails
{
    static targetCoords : Record < string,
    TargetLocation > = {
        "AORTA": {
            "x": 300,
            "y": 300,
            "isConduit": true,
            "isFree": true,
            "backOfHeart": false
        },
        "AORTAEND": {
            "x": 316,
            "y": 165,
            "backOfHeart": false,
            "isFree": false
        },
        "AORTAYEND": {
            "x": 385,
            "y": 145,
            "backOfHeart": false,
            "isFree": true
        },
        "LITA": {
            "x": 585,
            "y": 150,
            "isConduit": true,
            "isMammary": true,
            "backOfHeart": false,
            "isFree": false
        },
        "LITAEND": {
            "x": 700,
            "y": 90,
            "backOfHeart": false,
            "isFree": false
        },
        "LITAYEND": {
            "x": 850,
            "y": 140,
            "backOfHeart": false,
            "isFree": false
        },
        "RITA": {
            "x": 188,
            "y": 180,
            "isConduit": true,
            "isMammary": true,
            "backOfHeart": false,
            "isFree": false
        },
        "RITAEND": {
            "x": -60,
            "y": 110,
            "backOfHeart": false,
            "isFree": false
        },
        "RITAYEND": {
            "x": -70,
            "y": 150,
            "backOfHeart": false,
            "isFree": false
        },
        "RA": {
            "x": 300,
            "y": 300,
            "isConduit": true,
            "isFree": true,
            "backOfHeart": false
        },
        "RAEND": {
            "x": 320,
            "y": 150,
            "backOfHeart": false,
            "isFree": false
        },
        "SVG": {
            "x": 300,
            "y": 300,
            "isConduit": true,
            "isFree": true,
            "backOfHeart": false
        },
        "SVGEND": {
            "x": 380,
            "y": 180,
            "backOfHeart": false,
            "isFree": false
        },
        "GEA": {
            "x": -120.00001525878906,
            "y": 834.9999694824219,
            "isConduit": true,
            "backOfHeart": false,
            "isFree": false
        },
        "GEAEND": {
            "x": 30,
            "y": 700,
            "backOfHeart": false,
            "isFree": false
        },
        "GEAYEND": {
            "x": 100,
            "y": 650,
            "backOfHeart": false,
            "isFree": false
        },
        "RCA": {
            "x": 244,
            "y": 526,
            "isConduit": true,
            "isFree": true,
            "backOfHeart": false
        },
        "RVB": {
            "x": 328,
            "y": 400,
            "backOfHeart": false,
            "isFree": false
        },
        "AM": {
            "x": 310,
            "y": 557,
            "backOfHeart": false,
            "isFree": false
        },
        "PDA": {
            "x": 400,
            "y": 565,
            "backOfHeart": true,
            "isFree": false
        },
        "LVB": {
            "x": 400,
            "y": 514,
            "backOfHeart": true,
            "isFree": false
        },
        "LAD": {
            "x": 510,
            "y": 560,
            "backOfHeart": false,
            "isFree": false
        },
        "DIAG": {
            "x": 542,
            "y": 542,
            "backOfHeart": false,
            "isFree": false
        },
        "DIAG2": {
            "x": 542,
            "y": 612,
            "backOfHeart": false,
            "isFree": false
        },
        "RI": {
            "x": 500,
            "y": 395,
            "backOfHeart": false,
            "isFree": false
        },
        "CX": {
            "x": 536,
            "y": 357,
            "backOfHeart": false,
            "isFree": false
        },
        "OM1": {
            "x": 564,
            "y": 467,
            "backOfHeart": false,
            "isFree": false
        },
        "OM2": {
            "x": 496,
            "y": 435,
            "backOfHeart": true,
            "isFree": false
        },
        "PLA": {
            "x": 441,
            "y": 494,
            "backOfHeart": true,
            "isFree": false
        },
        "CIA": {
            "x": 27,
            "y": 90,
            "backOfHeart": false,
            "isFree": false
        },
        "EIA": {
            "x": 42,
            "y": 140,
            "backOfHeart": false,
            "isFree": false
        },
        
        "CFA": {
            "x": 60,
            "y": 200,
            "backOfHeart": false,
            "isFree": false
        },
        "PFA": {
            "x": 65,
            "y": 310,
            "backOfHeart": false,
            "isFree": false
        },
        "SFA": {
            "x": 45,
            "y": 380,
            "backOfHeart": false,
            "isFree": false
        },
        "POP_ATK": {
            "x": 54,
            "y": 565,
            "backOfHeart": false,
            "isFree": false
        },
        "POP_BTK": {
            "x": 50,
            "y": 630,
            "backOfHeart": false,
            "isFree": false
        },
        "ATA": {
            "x": 60,
            "y": 810,
            "backOfHeart": false,
            "isFree": false
        },
        "PTA": {
            "x": 32,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "PA": {
            "x": 45,
            "y": 840,
            "backOfHeart": false,
            "isFree": false
        },
        "RADIAL-CEPHALIC": {
            "x": 260,
            "y": 780,
            "backOfHeart": false,
            "isFree": false
        },
        "RADIAL-BASILIC": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "RADIAL-VEINBRACHIAL": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "RADIAL-MEDIANCUBITAL": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "RADIAL-AXILLARY": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "ULNAR-CEPHALIC": {
            "x": 313,
            "y": 862,
            "backOfHeart": false,
            "isFree": false
        },
        "ULNAR-BASILIC": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "ULNAR-VEINBRACHIAL": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "ULNAR-MEDIANCUBITAL": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "ULNAR-AXILLARY": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "ARTERYBRACHIAL-CEPHALIC": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "ARTERYBRACHIAL-BASILIC": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "ARTERYBRACHIAL-VEINBRACHIAL": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "ARTERYBRACHIAL-MEDIANCUBITAL": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        },
        "ARTERYBRACHIAL-AXILLARY": {
            "x": 320,
            "y": 800,
            "backOfHeart": false,
            "isFree": false
        }

    }

    static targetDetailsDefined : Record < string,
    TargetDetail > = {
        "LITA": {
            priority: 0,
            mostUsed: true,
            isSource: true
        },
        "RITA": {
            priority: 1,
            isSource: true
        },
        "RA": {
            priority: 1,
            color: "var(--GreenApple)"
        },
        "SVG": {
            priority: 0,
            color: "var(--Bluejay)"
        },
        "GEA": {
            priority: 2,
            color: "var(--Raven)",
            isSource: true
        },
        "RCA": {
            priority: 1
        },
        "RVB": {
            priority: 1
        },
        "AM": {
            priority: 1
        },
        "PDA": {
            priority: 1
        },
        "LVB": {
            priority: 1
        },
        "CUSTOM": {
            priority: 2,
            color: "var(--GreenApple)"
        },
        "LAD": {
            priority: 0
        },
        "DIAG": {
            priority: 0
        },
        "DIAG2": {
            priority: 0
        },
        "RI": {
            priority: 0
        },
        "CX": {
            priority: 0
        },
        "OM1": {
            priority: 0
        },
        "OM2": {
            priority: 0
        },
        "PLA": {
            priority: 0
        },
        "PROSTHETIC": {
            priority: 0,
            color: "var(--Crocodile)",
            vascular: true
        },
       
        "BIOGRAFT": {
            priority: 0,
            color: "var(--BananaClan)",
            vascular: true
        },
        "Synthetic": {
            priority: 0,
            color: "var(--swan)",
            vascular: true
        },
       
        "Bovine": {
            priority: 0,
            color: "var(--Raven)",
            vascular: true
        },
        "None": {
            priority: 0,
            color: "var(--BananaClan)",
            vascular: true
        },
        "Vein": {
            priority: 0,
            color: "var(--Bluejay)",
            vascular: true
        },
        "VEIN": {
            priority: 0,
            color: "var(--Bluejay)",
            vascular: true
        },

        "CIA": {
            priority: 0,
            vascular: true
        },
        "EIA": {
            priority: 0,
            vascular: true
        },
        "CFA": {
            priority: 0,
            vascular: true
        },
        "SFA": {
            priority: 0,
            vascular: true
        },
        "PFA": {
            priority: 0,
            vascular: true
        },
        "POP_ATK": {
            priority: 0,
            vascular: true
        },
        "POP_BTK": {
            priority: 0,
            vascular: true
        },
        "ATA": {
            priority: 0,
            vascular: true
        },
        "PTA": {
            priority: 0,
            vascular: true
        },
        "PA": {
            priority: 0,
            vascular: true
        },
        "SA": {
            upperLimb: true,
            priority: 0,
            vascular: true
        },
        "AA": {
            upperLimb: true,
            priority: 0,
            vascular: true
        },"ASCAORTA": {
            isSource: true,
            priority: 0,
            vascular: true
        },
        "ABAORTA": {
            isSource: true,
            priority: 0,
            vascular: true
        },
        "RADIAL-CEPHALIC": {
            priority: 0,
            vascular: true
        },
        "RADIAL-BASILIC": {
            priority: 0,
            vascular: true
        },
        "RADIAL-VEINBRACHIAL": {
            priority: 0,
            vascular: true
        },
        "RADIAL-MEDIANCUBITAL": {
            priority: 0,
            vascular: true
        },
        "RADIAL-AXILLARY": {
            priority: 0,
            vascular: true
        },
        "ULNAR-CEPHALIC": {
            priority: 0,
            vascular: true
        },
        "ULNAR-BASILIC": {
            priority: 0,
            vascular: true
        },
        "ULNAR-VEINBRACHIAL": {
            priority: 0,
            vascular: true
        },
        "ULNAR-MEDIANCUBITAL": {
            priority: 0,
            vascular: true
        },
        "ULNAR-AXILLARY": {
            priority: 0,
            vascular: true
        },
        "ARTERYBRACHIAL-CEPHALIC": {
            priority: 0,
            vascular: true
        },
        "ARTERYBRACHIAL-BASILIC": {
            priority: 0,
            vascular: true
        },
        "ARTERYBRACHIAL-VEINBRACHIAL": {
            priority: 0,
            vascular: true
        },
        "ARTERYBRACHIAL-MEDIANCUBITAL": {
            priority: 0,
            vascular: true
        },
        "ARTERYBRACHIAL-AXILLARY": {
            priority: 0,
            vascular: true
        }
    }


    public static getTargetCoords(heartCanvas : HeartDrawingOverlay, TargetName : string, firstTargetIsOnLeft : boolean = false, drawingStartPoint?: TargetLocation) : TargetLocation
    {
        let hemisphereIn: Hemisphere | null = null;
        if (!this.targetCoords[TargetName] && TargetName && TargetName.indexOf("-") > -1)
        {
            hemisphereIn = TargetName.substr(TargetName.indexOf("-") + 1, TargetName.length - TargetName.indexOf("-") - 1) as Hemisphere;
            TargetName = TargetName.substr(0, TargetName.indexOf("-"));
        }
        if (TargetName === "CUSTOM") {
            let locationTransfer = heartCanvas.transferFromScreenSize(heartCanvas.props.customGraftLocation);
            let customGraft : TargetLocation = {
                x: locationTransfer.x,
                y: locationTransfer.y,
                backOfHeart: heartCanvas.props.customGraftLocation.backOfHeart
            }
            return customGraft;
        }

        // If it includes FREE in the name remove it and if it is a source then return
        // the AORTA location.
        if (TargetName && TargetName.indexOf("FREE") > -1) {
            TargetName = TargetName.replace("FREE", "");
            let isEnd = TargetName.indexOf("END") > -1;
            var CleanName = TargetName
                .replace("YEND", "")
                .replace("END", "");
            if (TargetDetails.getTargetDetail(CleanName) && TargetDetails.getTargetDetail(CleanName).isSource) {
                let locationGraft : TargetLocation = {
                    x: this.targetCoords["AORTA" + (isEnd
                            ? "END"
                            : "")].x,
                    y: this.targetCoords["AORTA" + (isEnd
                            ? "END"
                            : "")].y,
                    backOfHeart: this.targetCoords[TargetName].backOfHeart,
                    isConduit: this.targetCoords[TargetName].isConduit,
                    isFree: true,
                    isMammary: this.targetCoords[TargetName].isMammary
                }
                return locationGraft;
            }
        }

        if (this.targetCoords[TargetName] && this.targetCoords[TargetName].backOfHeart === undefined) 
            this.targetCoords[TargetName].backOfHeart = false;
        if (this.targetCoords[TargetName] && this.targetCoords[TargetName].isFree === undefined) 
            this.targetCoords[TargetName].isFree = false;
        let isEnd = TargetName ? TargetName.indexOf("END") > -1 : false;
        if (TargetName)
        TargetName = TargetName
                .replace("YEND", "")
                .replace("END", "");

        if (this.targetCoords[TargetName] && this.targetCoords[TargetName].isConduit) {
            let xOffset = 0;
            let yOffset = 0;
            // if conduit is from the Aorta and it is going to a target on the left (Stage
            // Left! ---->) of the heart then it should start more to the left on the Aorta.

            if (this.targetCoords[TargetName].isFree && firstTargetIsOnLeft) {
                xOffset = 30;
            }
            // If its a conduit and there is already another one drawn then add an increment
            // so it doesn't overlap too badly.
            let targetCoordToUse = this.targetCoords[TargetName] as TargetLocation;
            //If it's the preview of an END then add a base offset 
            if (isEnd)
            {
                //Add the offset to the drawing start point if one was given.
                if (drawingStartPoint)
                    targetCoordToUse = drawingStartPoint;
                if (targetCoordToUse.x)
                {
                //If it's on the right hand side of the heart then offset inwards and if its on the left add a positive one.
                let offsetInput = ((heartCanvas.findHeartCenter() as Coordinate).x as number) < targetCoordToUse.x ? -50 : 50;

                xOffset = xOffset + offsetInput;
                //Offset downwards always with the exception of the GEA where it needs to go upwards.
                yOffset = yOffset + (TargetName === "GEA" ? -250 : 250);
                }
            }
            else{
                yOffset = yOffset + heartCanvas.targetYOffsets[TargetName];
            }

            

            let locationGraft : TargetLocation = {
                x: targetCoordToUse.x ? targetCoordToUse.x + xOffset : xOffset,
                y: targetCoordToUse.y ? targetCoordToUse.y  + yOffset : yOffset,
                backOfHeart: this.targetCoords[TargetName].backOfHeart,
                isConduit: this.targetCoords[TargetName].isConduit,
                isFree: this.targetCoords[TargetName].isFree,
                isMammary: this.targetCoords[TargetName].isMammary
            }
            return locationGraft;
        }
        let locationGraft = { ...this.targetCoords[TargetName] };
        if (hemisphereIn)
        {
            //If a hemisphere was specified then give the point relative to the heart center.
            //This assumes symmetry of the targets we draw on.
           // locationGraft.x = (heartCanvas.transferFromScreenSize(heartCanvas.findHeartCenter()).x as number) + (hemisphereIn === Hemisphere.LEFT ? -1 : 1 ) * (locationGraft.x as number) +  (hemisphereIn === Hemisphere.LEFT ? 0 : 50 ) ;

        }

        return locationGraft;
    }

    // public static getTargetCoordsVascular(vascularCanvas : VascularDrawingOverlay, TargetName : string, firstTargetIsOnLeft : boolean = false, drawingStartPoint: TargetLocation = null) : TargetLocation
    // {
    //     let hemisphereIn: Hemisphere;
    //     if (!this.targetCoords[TargetName] && TargetName && TargetName.lastIndexOf("-") > -1)
    //     {
    //         hemisphereIn = TargetName.substr(TargetName.lastIndexOf("-") + 1, TargetName.length - TargetName.lastIndexOf("-") - 1) as Hemisphere;
    //         TargetName = TargetName.substr(0, TargetName.lastIndexOf("-"));
    //     }
    //     // if (TargetName === "CUSTOM") {
    //     //     let locationTransfer = heartCanvas.transferFromScreenSize(heartCanvas.props.customGraftLocation);
    //     //     let customGraft : TargetLocation = {
    //     //         x: locationTransfer.x,
    //     //         y: locationTransfer.y,
    //     //         backOfHeart: heartCanvas.props.customGraftLocation.backOfHeart
    //     //     }
    //     //     return customGraft;
    //     // }


       
    //     let locationGraft = { ...this.targetCoords[TargetName] };
    //     if (hemisphereIn)
    //     {
    //         //If a hemisphere was specified then give the point relative to the heart center.
    //         //This assumes symmetry of the targets we draw on.
    //         locationGraft.x = vascularCanvas.transferFromScreenSize(vascularCanvas.findBodyCenter()).x + (hemisphereIn === Hemisphere.LEFT ? 1 : -1 ) * locationGraft.x +  (hemisphereIn === Hemisphere.LEFT ? 50 : 0 ) ;

    //     }

    //     return locationGraft;
    // }

    public static getTargetDetail(targetOrConduit: string) : TargetDetail
    {
        targetOrConduit = (targetOrConduit
            ? targetOrConduit.replace("FREE", "")
            : "");
        if (!this.targetDetailsDefined[targetOrConduit]) {
            console.log("INVALID TARGET: " + targetOrConduit);
            return { priority:0};
        }

        if (!this.targetDetailsDefined[targetOrConduit].color) {
            this.targetDetailsDefined[targetOrConduit].color = "var(--BernRed)";
        }
        return this.targetDetailsDefined[targetOrConduit];
    }
    public static getIsVein(colorOfVessel: string) : boolean
    {
      
        return (colorOfVessel === "var(--Bluejay)" || colorOfVessel === "var(--Crocodile)" || colorOfVessel === "var(--GreenApple)" || colorOfVessel === "var(--BananaClan)")
        
    }
}

